import * as React from 'react';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
const styles  = (theme: Theme) => createStyles({
  metroItem: {
    border: '3px solid white',
    width: 130,
    height: 130,
    margin: '5px 15px',
    cursor: 'pointer',
    textAlign: 'center',
    backgroundColor: '#2196F3',
    borderRadius: 3,
    '& .inner': {
    },
    '& img': {
      width: 60,
      marginTop: 20
    },
    '& p': {
      color: 'white',
      fontSize: 12,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      fontFamily: `'Open Sans', sans-serif`
    },
    '& inner:nth-child(2)': {
      marginRight: 30
    },
  }
});

type Props = {
  title: string;
  icon?: string;
  path: string;
  backgroundColor: string;
  isExternal?: boolean;
  isMargin?:number;
}
  & WithStyles<typeof styles>;

type States = {

};

class MetroItemComponent extends React.PureComponent<Props, States>{
  constructor(props: Props) {
    super(props);
    this.state = {

    };
  }
  render() {
    const { classes, title, icon, path, backgroundColor, isExternal } = this.props;
    const component = <div className={classes.metroItem} style={{ backgroundColor: backgroundColor }}>
      <div className="inner">
        <img src={icon} alt={title} />
        <p>{title}</p>
      </div>
    </div>;
    if (isExternal) {
      return <a href={path} target="_blank">
        {component}
      </a>;
    }
    return <Link to={path}>
      {component}
    </Link>;
  }
}

export default withStyles(styles)(MetroItemComponent);
